import { getDefaultHeader } from '../../services/serviceAPIHelper';

export async function getUnsolved() {
    const url = process.env.REACT_APP_API_URL_V2 + 'backoffice/payments/unsolved';
    const response = await fetch(url, {
        method: 'GET',
        headers: getDefaultHeader(true)
    });

    if (response.ok) {
        return await response.json();
    }
    else {
        const error = await response.json();
        throw error;
    }
}

export async function doResolve(payments) {
    const url = process.env.REACT_APP_API_URL_V2 + 'backoffice/payments/resolve';
    const payload = payments.map((payment) => payment.merchantOperationId);
    
    const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: getDefaultHeader(true),
    });

    if (response.ok) {
        return await response.json();
    }
    else {
        const error = await response.json();
        throw error;
    }
}

export async function updateSchema() {
    const url = process.env.REACT_APP_API_URL_V2 + '/payments/updateschema';
    const response = await fetch(url, {
        method: 'GET',
        headers: getDefaultHeader(true)
    });

    if (response.ok) {
        return await response.json();
    }
    else {
        const error = await response.json();
        throw error;
    }
}


// WEBPACK FOOTER //
// ./src/components/Payments/paymentsService.js